import React from 'react';
import { DownloadIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toIntlDateTimeFormat } from '@zedoc/date';
import Button from '../../Button';

const noop = () => {};

const CustomPDF = ({
  title,
  projectName,
  milestoneName,
  completedAt,
  answersSheets,
  recipientId,
  activityId,
  onDownload,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return (
    <div className="cluster-4 items-center justify-between flex-wrap">
      <div>
        <p className="font-semibold">{title}</p>
        {projectName && (
          <p className="text-sm text-secondary">
            {`${t('projects', { count: 1 })}: ${[projectName]}`}
          </p>
        )}
        {milestoneName && (
          <p className="text-sm text-secondary">
            {`${t('milestones', { count: 1 })}: ${[milestoneName]}`}
          </p>
        )}
        {answersSheets?.length > 0 && (
          <p className="text-sm text-secondary">
            {answersSheets.map((sheet) => sheet.questionnaireId).join(', ')}
          </p>
        )}
        {completedAt && (
          <p className="text-sm text-secondary">
            {`${t('completedAt')} ${toIntlDateTimeFormat(
              language,
              completedAt,
              { dateStyle: 'short', timeStyle: 'short' },
            )}`}
          </p>
        )}
      </div>
      <div className="cluster-4 items-center flex-wrap">
        {onDownload && (
          <Button type="ghost" icon={<DownloadIcon />} onClick={onDownload}>
            {t('download')}
          </Button>
        )}
      </div>
    </div>
  );
};

CustomPDF.propTypes = {
  title: PropTypes.string.isRequired,
  projectName: PropTypes.string,
  milestoneName: PropTypes.string,
  completedAt: PropTypes.instanceOf(Date),
  answersSheets: PropTypes.array,
  recipientId: PropTypes.string,
  activityId: PropTypes.string,
  onDownload: PropTypes.func,
};

CustomPDF.defaultProps = {
  projectName: null,
  milestoneName: null,
  completedAt: null,
  answersSheets: [],
  recipientId: null,
  activityId: null,
  onDownload: noop,
};

export default CustomPDF;
